import React, { useEffect, useState, useRef, useCallback, lazy, Suspense, useMemo } from 'react';
import VideoPoster from '../../assets/img/video-thumbnail.png';
import VideoPoster2 from '../../assets/img/video_thumb.png';
import Footer from './footer';
import MainHeader from './header';
import { useScript } from '../../hooks/script';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import '../../assets/styles/landing-pages.css';
import { routes } from '../routes/routes-names';
import { Helmet } from 'react-helmet';
import fbNew from '../../assets/img/fb-new.svg';
import linkedinNew from '../../assets/img/linkedin-new.svg';
import clientTestimonialImg from '../../assets/img/client-testimonial.png';
import wallero from '../../assets/img/company-logo-dark.png';
import contactWidget from '../../assets/img/contact-widget.svg';
import clientQuote from '../../assets/img/client-quote.svg';
import testiSmallImg1 from '../../assets/img/testiSmallImg1.png';
import testiSmallImg4 from '../../assets/img/testiImg5-crop.png';
import implantaire from '../../assets/img/implantaire-3.png';
import acviss from '../../assets/img/acvisss.png';
import ulearn from '../../assets/img/ulearn.png';
import testiImg2 from '../../assets/img/testImg2.png';
import testiImg4 from '../../assets/img/testiImg4.png';
import testiImg5 from '../../assets/img/testiImg5.png';
import testiImg6 from '../../assets/img/testiImg6.png';
import testiSmallImg6 from '../../assets/img/testiImg6-crop.jpeg';
import testiImg7 from '../../assets/img/testiImg7.png';
import testiSmallImg7 from '../../assets/img/testiImg7-crop.jpg';
import testiSmallImg8 from '../../assets/img/rajiv-tiwari.jpg';
import testiImg8 from '../../assets/img/testiImg8.png';
import testiImg9 from '../../assets/img/testiImg9.png';
import testiSmallImg9 from '../../assets/img/testiImg9.png';
import inspiringTouch from '../../assets/img/inspiring_touch.png';
import revSoc from '../../assets/img/revsoc.png';
import virtusaLogo from '../../assets/img/virtusa-logo.svg';
import comtecLogo from '../../assets/img/comtec.png';
import { OpenAPIService } from '../../lib/api/openApi';
import { Form } from 'react-bootstrap';
import { Counter } from './counter';
import { sessionStorageSetItem } from '../../components/storage/sessionStorageManager';
import { ClientLogo50 } from './clientLogo-50';
import { LandingPageMessages, testimonialIndicatorButton } from '../../lib/constants/landingPageMessages';
import { LandingPageCounters } from '../../lib/constants/landingPageCarousels';
import candidateAvatar from '../../assets/img/avatar-grey.png';
import companyLogo from '../../assets/img/logo.svg';
import ClaimedSearchBox, { decryptData, encodeProfileId } from '../claimed/search-box';
import { localStorageRemoveItem, localStorageSetItem } from '../../components/storage/localStorageManager';
import hero2 from '../../assets/img/hero2.svg';
import feature1 from '../../assets/img/feature1.svg';
import feature2 from '../../assets/img/feature2.svg';
import feature3 from '../../assets/img/feature3.svg';
import feature4 from '../../assets/img/feature4.svg';
import feature5 from '../../assets/img/feature5.svg';
import feature6 from '../../assets/img/feature6.svg';
import ShowCaseProgress from './ShowCaseProgress';
import ShowCaseData from './ShowCaseData.json';
import { WebinarCards } from '../../lib/constants/webinarCards';
import { companyService } from '../../lib/api/company';
import { SortTypeEnum } from '../../types';
import { CompanyListRequestType } from '../../types/company';
import companyAvatar from '../../assets/img/logo.svg';
import StateCityCodeValue from '../../components/profile/stateCityCodeValue';
import { Skeleton } from 'primereact/skeleton';
import FAQImg from '../../assets/img/faq-search-icon.png';
import { candidateService } from '../../lib/api/candidate';
import { deleteReduxProfile } from '../../redux/registration';
import { useDispatch } from 'react-redux';

// Video URLs (consider CDN optimization)
const VIDEO_URLS = {
    OfferxVideo:
        'https://offerxprodsa.blob.core.windows.net/homepagevideos/NewofferXVideo.mp4?sp=r&st=2025-08-07T08:47:20Z&se=2027-08-08T17:02:20Z&spr=https&sv=2024-11-04&sr=b&sig=9WY%2Ba9kt5uluc9CSqTPlYDGz1famgvr%2F4QiP0d5irPc%3D',
    ClientTestiVideo:
        'https://offerxprodsa.blob.core.windows.net/homepagevideos/Offerx%20Testimonial%20Final_Compressed.mp4?sp=r&st=2025-08-07T08:42:16Z&se=2027-08-08T16:57:16Z&spr=https&sv=2024-11-04&sr=b&sig=b48KUBuy1o1%2FUw8tNzmGj%2F3SPx%2BICTRJGrIKXYL7CxM%3D',
};

declare global {
    interface Window {
        AOS?: {
            init: () => void;
        };
    }
}

// type Props = RouteComponentProps;

const Main: React.FC = () => {
    const location = useLocation();
    const { ConfirmCandidateInvitationId, ConfirmManagerInvitationId } = queryString.parse(location.search);
    const aosReady = useScript('https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.js');
    const [videwShow, setVideoShow] = useState<boolean>(false);
    const [videwShowClient, setVideoShowClient] = useState<boolean>(false);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [index, setIndex] = useState<number>(0);
    const [expandedIndex, setExpandedIndex] = useState(false);
    const [loading, setLoading] = useState<boolean>();
    const [page, setPage] = useState<number>(1);

    // const [start, setStart] = useState(1);
    const [limit, setLimit] = useState(10);
    const [filterText, setFilterText] = useState<string>('');
    // const [sort, setSort] = useState<{ [key: string]: SortTypeEnum } | null>(null);
    const [items, setItems] = useState<any[]>([]);
    const [searchLoading, setSearchLoading] = useState(false);

    const [showBanner, setShowBanner] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);

    const [searchType, setSearchType] = useState('candidate');

    const searchWrapperRef = useRef<HTMLDivElement>(null);

    // const handleBannerClose = () => setShowBanner(false);

    // const hasCandidate = user.role === UserRoleEnum.candidate;

    const [show, setShow] = useState(false);

    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const latestWebinars = useMemo(() => [...WebinarCards].slice(0, 3), []);

    const inputDropdownRef = useRef<HTMLUListElement>(null);
    const [showInputDropdown, setShowInputDropdown] = useState(false);

    const handleInputClick = () => {
        setShowInputDropdown(true);
    };

    const handleBlur = (event: any) => {
        // Ensure inputDropdownRef is not null and handle contains method safely
        if (inputDropdownRef.current && !inputDropdownRef.current.contains(event.relatedTarget)) {
            setShowInputDropdown(false);
        }
    };

    const handleSelect = (selectedIndex: number) => {
        setIndex(selectedIndex);
    };

    const getExternalPaginatedList = useCallback(async () => {
        try {
            setLoading(true);
            const params: CompanyListRequestType = {
                Start: page,
                Limit: limit,
                'SearchParam.FilterValue': filterText,
                'SearchParam.SortType': 1,
            };
            const { resultObject } =
                searchType === 'company'
                    ? await companyService.getCompanyExternalList(params)
                    : await candidateService.getCandidateExternalList(params);

            setItems((prevItems) => {
                if (page === 1) {
                    return resultObject;
                }
                return [...prevItems, ...resultObject];
            });
        } catch (err) {
            console.error('Error fetching external list:', err);
        } finally {
            setLoading(false);
            setSearchLoading(false);
        }
    }, [page, limit, filterText, searchType]);

    const onScrollChange = (event: React.UIEvent<HTMLElement>) => {
        const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
        const height = Math.round(scrollTop) + clientHeight;

        if (height >= scrollHeight - 10 && !loading) {
            setPage((prevPage) => prevPage + limit);
        }
    };

    useEffect(() => {
        if (!aosReady) return;
        window.AOS?.init();
    }, [aosReady]);

    const handleAutoClick = () => {
        if (buttonRef.current) {
            buttonRef.current.click();
        }
    };

    useEffect(() => {
        handleAutoClick();
        localStorageRemoveItem('unclaimed');
        // localStorageRemoveItem('seosearch');
        localStorageRemoveItem('claimedType');
        localStorageRemoveItem('phoneNumber');
        dispatch(deleteReduxProfile());
    }, []);

    useEffect(() => {
        const carousel = document.getElementById('testimonialIndicators');
        let handleSlide: (() => void) | undefined;
        if (carousel) {
            handleSlide = () => {
                setExpandedIndex(false);
            };
            carousel.addEventListener('slide.bs.carousel', handleSlide);
        }
        return () => {
            if (carousel && handleSlide) {
                carousel.removeEventListener('slide.bs.carousel', handleSlide);
            }
        };
    }, []);

    useEffect(() => {
        const getAllData = async () => {
            const country = await OpenAPIService.fetchCountriesWithPhoneCode();
            const state = await OpenAPIService.fetchAllStates();

            sessionStorageSetItem('countries', country, false);
            sessionStorageSetItem('states', state, false);
        };

        getAllData();
    }, []);

    const handleSelectedExpand = () => {
        // console.log('test');
    };

    const takeToTheRoute = (decryptedData: any, companyStatus: number, companyType: number, searchRoleType: string) => {
        const { id, name, firstName, lastName } = decryptedData;

        if (searchRoleType === 'candidate') {
            navigate(
                `/candidate/pub/${encodeName(firstName?.replace(/\s+/g, '') || 'NA')}-${encodeName(
                    lastName?.replace(/\s+/g, '') || 'NA'
                )}-${encodeProfileId(id)}`,

                {
                    state: {
                        data: { ...decryptedData, claimedType: 'candidate' },
                    },
                }
            );
        } else {
            navigate(
                `/company/pub/${encodeName(name.replace(/\s+/g, '') || 'NA')}-${encodeProfileId(id || '')}`,

                {
                    state: {
                        data: { ...decryptedData, claimedType: 'company', navigationTimestamp: Date.now() },
                    },
                }
            );
        }
    };

    useEffect(() => {
        if (filterText.trim() === '') {
            setItems([]);
            setSearchLoading(false);
            return;
        }

        const delayDebounce = setTimeout(() => {
            getExternalPaginatedList();
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [page, limit, filterText, getExternalPaginatedList]);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (searchWrapperRef.current && !searchWrapperRef.current.contains(event.target as Node)) {
                setShowDropdown(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setFilterText('');
    }, [searchType]);

    const Webinars = lazy(() => import('../main/webinars'));

    return (
        <>
            <Helmet>
                <title>OfferX </title>
                <meta name="description" content="Say goodbye to Recruitment Ghosting." />
                {/* <link rel="preload" as="video" href={OfferxVideo} /> */}
            </Helmet>
            <MainHeader
                candidateId={
                    typeof ConfirmCandidateInvitationId === 'string' ? ConfirmCandidateInvitationId : undefined
                }
                managerId={typeof ConfirmManagerInvitationId === 'string' ? ConfirmManagerInvitationId : undefined}
            />
            {/* Opening banner starts */}
            {/* {pluggableBanner && <Banner show={showBanner} handleBannerClose={handleBannerClose} />} */}
            {/* Opening banner ends */}
            <section className="hero-banner plan-bg">
                <div className="container">
                    <div className="row text-lg-start text-xl-start text-center">
                        <div className="col-lg-7 col-sm-12">
                            <div className="hero-content mt-5" data-aos="fade-up" data-aos-delay="200">
                                <div className="fs-32 fw-700 lt-text-primary mb-2">
                                    Say Goodbye To <br />
                                    <span className="lt-text-primary-alt">Recruitment Ghosting</span>
                                </div>{' '}
                                <div className="external-search-width">
                                    <p className="fs-14 mb-4">
                                        OfferX brings balance to the system and enhances commitment on both sides,
                                        providing stability and predictability to job offers.
                                    </p>
                                    <div className="d-flex mb-2">
                                        <div className="d-flex me-3">
                                            <input
                                                type="radio"
                                                className="me-2 cursor-pointer"
                                                name="search-type"
                                                id="candSearch"
                                                checked={searchType === 'candidate'}
                                                onChange={() => setSearchType('candidate')}
                                            />
                                            <label className="cursor-pointer" htmlFor="candSearch">
                                                Search Candidate
                                            </label>
                                        </div>
                                        <div className="d-flex">
                                            <input
                                                type="radio"
                                                className="me-2 cursor-pointer"
                                                name="search-type"
                                                id="compSearch"
                                                checked={searchType === 'company'}
                                                onChange={() => setSearchType('company')}
                                            />
                                            <label className="cursor-pointer" htmlFor="compSearch">
                                                Search Company
                                            </label>
                                        </div>
                                    </div>

                                    <div ref={searchWrapperRef} className="mb-5">
                                        <div className="external-search animation-border">
                                            <i className="bi bi-search searchIcon"></i>
                                            <Form.Control
                                                // size="lg"
                                                type="text"
                                                placeholder={
                                                    searchType === 'candidate'
                                                        ? 'Search by candidate name'
                                                        : 'Search by company name'
                                                }
                                                value={filterText}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setPage(1);
                                                    if (filterText.length > 0) {
                                                        setShowDropdown(true);
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    setSearchLoading(true);
                                                    setItems([]);
                                                    setFilterText(e.target.value);
                                                    setPage(1);
                                                    setShowDropdown(true);
                                                }}
                                            />
                                        </div>
                                        {showDropdown && (
                                            <div className="external-search-dropdown">
                                                {searchLoading ? (
                                                    <div className="card external-search-card lt-shadow-md">
                                                        <div className="card-body">
                                                            <ul>
                                                                <li>
                                                                    <div className="d-flex align-items-center cursor-pointer">
                                                                        <Skeleton
                                                                            width="42px"
                                                                            height="42px"
                                                                            className="custom-skeleton border-radius-50-per me-2"
                                                                        ></Skeleton>
                                                                        <div className="flex-column">
                                                                            <div className="fw-600 mb-2">
                                                                                <Skeleton
                                                                                    width="210px"
                                                                                    height="15px"
                                                                                    className="custom-skeleton"
                                                                                ></Skeleton>
                                                                            </div>
                                                                            <div className="fs-14 lt-text-secondary">
                                                                                <Skeleton
                                                                                    width="140px"
                                                                                    height="15px"
                                                                                    className="custom-skeleton"
                                                                                ></Skeleton>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                ) : items?.length > 0 ? (
                                                    <>
                                                        {items?.length > 0 && (
                                                            <div
                                                                className="external-list-card"
                                                                onScroll={onScrollChange}
                                                            >
                                                                {items?.map((item) => {
                                                                    const {
                                                                        name,
                                                                        cityDistrict,
                                                                        state,
                                                                        country,
                                                                        avatarUrl,
                                                                        companyEmail,
                                                                        companyStatus,
                                                                        companyType,
                                                                        firstName,
                                                                        lastName,
                                                                        candidateLocation,
                                                                    } = item;

                                                                    return (
                                                                        <div
                                                                            className="card external-search-card"
                                                                            key={item?.id}
                                                                        >
                                                                            <div className="card-body">
                                                                                <ul>
                                                                                    <li
                                                                                        onClick={() => {
                                                                                            localStorageRemoveItem(
                                                                                                'Email'
                                                                                            );
                                                                                            takeToTheRoute(
                                                                                                item,
                                                                                                companyStatus,
                                                                                                companyType,
                                                                                                searchType
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        <div className="d-flex align-items-center cursor-pointer">
                                                                                            <img
                                                                                                src={
                                                                                                    avatarUrl
                                                                                                        ? avatarUrl
                                                                                                        : searchType ===
                                                                                                          'candidate'
                                                                                                        ? candidateAvatar
                                                                                                        : companyAvatar
                                                                                                }
                                                                                                className="avatar avatar--xxss me-2"
                                                                                                alt=""
                                                                                            />
                                                                                            <div className="flex-column">
                                                                                                <div className="text-start fs-14">
                                                                                                    {name ||
                                                                                                        firstName +
                                                                                                            ' ' +
                                                                                                            lastName}
                                                                                                </div>
                                                                                                <div className="fs-12 lt-text-secondary text-start">
                                                                                                    {!cityDistrict ||
                                                                                                    cityDistrict ===
                                                                                                        '0' ||
                                                                                                    !state ||
                                                                                                    state === '0' ? (
                                                                                                        <>
                                                                                                            {!candidateLocation ||
                                                                                                            candidateLocation ===
                                                                                                                'NA' ? (
                                                                                                                'India'
                                                                                                            ) : (
                                                                                                                <>
                                                                                                                    <span>
                                                                                                                        {
                                                                                                                            candidateLocation
                                                                                                                        }
                                                                                                                    </span>
                                                                                                                    <span>
                                                                                                                        ,
                                                                                                                        India
                                                                                                                    </span>
                                                                                                                </>
                                                                                                            )}
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <StateCityCodeValue
                                                                                                            id=""
                                                                                                            countryValue={
                                                                                                                country
                                                                                                            }
                                                                                                            cityValue={
                                                                                                                cityDistrict
                                                                                                            }
                                                                                                            stateValue={
                                                                                                                state
                                                                                                            }
                                                                                                        />
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="external-list-card" onScroll={onScrollChange}>
                                                            <div className="react-select-no-results fs-14 my-2">
                                                                <div className="d-flex align-items-center justify-content-center py-1">
                                                                    <div className="text-center">
                                                                        <img
                                                                            src={FAQImg}
                                                                            alt="We could not find results for your search"
                                                                            className="ox-no-search-img"
                                                                        />
                                                                        <p className="fs-14">
                                                                            No results found. Try with another search.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <img fetchPriority="high" src={hero2} alt="" className="img-blog" />
                            </div>
                        </div>
                        <div className="col-lg-5 col-sm-12" data-aos="fade-up" data-aos-delay="200">
                            <div className="new-card">
                                <div className="fs-25 fw-600 mb-3">Features</div>

                                <div className="d-flex mb-4 align-items-center">
                                    <div>
                                        <img loading="lazy" src={feature5} width={30} className="me-3" alt="" />
                                    </div>
                                    <div className="flex-column text-mobile-left">
                                        <div className="fs-18 fw-600">Offer Tracking</div>
                                        <div className="fs-14 new-p-color">Real-time offer status updates.</div>
                                    </div>
                                </div>

                                <div className="d-flex mb-4 align-items-center">
                                    <div>
                                        <img loading="lazy" src={feature4} width={30} className="me-3" alt="" />
                                    </div>
                                    <div className="flex-column text-mobile-left">
                                        <div className="fs-18 fw-600">Two-Way Reviews</div>
                                        <div className="fs-14 new-p-color">Transparent hiring feedback.</div>
                                    </div>
                                </div>

                                <div className="d-flex mb-4 align-items-center">
                                    <div>
                                        <img loading="lazy" src={feature2} width={30} className="me-3" alt="" />
                                    </div>
                                    <div className="flex-column text-mobile-left">
                                        <div className="fs-18 fw-600">Job History Model</div>
                                        <div className="fs-14 new-p-color">Predicts candidate backouts.</div>
                                    </div>
                                </div>

                                <div className="d-flex mb-4 align-items-center">
                                    <div>
                                        <img loading="lazy" src={feature3} width={30} className="me-3" alt="" />
                                    </div>
                                    <div className="flex-column text-mobile-left">
                                        <div className="fs-18 fw-600">Offer Release</div>
                                        <div className="fs-14 new-p-color">Send offers instantly.</div>
                                    </div>
                                </div>

                                <div className="d-flex mb-4 align-items-center">
                                    <div>
                                        <img loading="lazy" src={feature6} width={30} className="me-3" alt="" />
                                    </div>
                                    <div className="flex-column text-mobile-left">
                                        <div className="fs-18 fw-600">E-Sign</div>
                                        <div className="fs-14 new-p-color">Seamless digital offer signing.</div>
                                    </div>
                                </div>

                                <div className="d-flex mb-5 align-items-center">
                                    <div>
                                        <img loading="lazy" src={feature1} width={30} className="me-3" alt="" />
                                    </div>
                                    <div className="flex-column text-mobile-left">
                                        <div className="fs-18 fw-600">Offer Punching</div>
                                        <div className="fs-14 new-p-color">Alerts HR on multiple job offers.</div>
                                    </div>
                                </div>

                                <NavLink
                                    to={routes.contact}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: 'none' }}
                                >
                                    <div className="explore-text">Explore All Features</div>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="lt-bg-white p-0 pb-2">
                <div className="text-center mb-4">
                    <div className="slider2">
                        <div className="slide-track2">
                            {ClientLogo50.map((item) => {
                                return (
                                    <div className="slide2">
                                        <img loading="lazy" src={item.img} height="30" alt={item.alt} />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>
            <section className="reg-light-blue px-3 py-4 ps-lg-0" style={{ zIndex: '-1', position: 'relative' }}>
                <div className="container">
                    <div className="row text-center">
                        {LandingPageCounters.map((item) => (
                            <div className="col-lg-3 col-md-6 col-12">
                                <div key={item.title}>
                                    <div className="fs-42 fw-600 lt-text-primary-alt">
                                        <div className="d-flex justify-content-center">
                                            <Counter start={item.start} end={item.end} />
                                            <span>+</span>
                                        </div>
                                    </div>
                                    <div className="fs-14">{item.title}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className="why-we-built px-3 ps-lg-0">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-md-12 text-center mb-4" data-aos="fade-up" data-aos-delay="200">
                            <h1 className="fw-600 fs-28 mb-3 lt-text-primary">Why We Built This?</h1>
                            <p className="lt-text-secondary fs-14">{LandingPageMessages.offerxBringsBalance}</p>
                        </div>
                        <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                            <p className="mb-3 lt-text-primary fs-16 fw-600">
                                Empowering Stability, Embracing Commitment.
                            </p>
                            <p className="mb-3 lt-text-primary fs-14">{LandingPageMessages.talentScarcity}</p>
                            <p className="mb-3 lt-text-primary fs-14">{LandingPageMessages.employersReleaseOffers}</p>
                            <NavLink to={routes.about} className={({ isActive }) => (isActive ? 'active' : '')}>
                                <button className="btn btn-primary border-radius-3">
                                    About us <i className="bi bi-arrow-right-circle-fill ms-1"></i>
                                </button>
                            </NavLink>
                        </div>
                        <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                            {/* <div className="aboutus-pic">
                                    <img loading='lazy'src={Built} className="img-fluid mx-auto d-block" alt="Why We Built This" />
                                </div> */}
                            <div className="position-relative">
                                <div
                                    className="ox-video-poster d-flex align-items-center justify-content-center cursor-pointer"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                    onClick={() => setVideoShow(true)}
                                >
                                    {!videwShow ? (
                                        <div className="text-center">
                                            <div className="circle">
                                                <i className="bi bi-play-fill play-icon"></i>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <video
                                                controls
                                                poster={VideoPoster2}
                                                preload="none"
                                                playsInline
                                                controlsList="nodownload"
                                                autoPlay
                                            >
                                                <source src={VIDEO_URLS.OfferxVideo} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="how-does-work py-5 reg-light-blue" data-aos="fade-up" data-aos-delay="200">
                <div className="container">
                    <div className="row">
                        <div className="col-md-7">
                            <div className="primary-gradient-text">How OfferX Works</div>
                            <div className="fs-36 mb-3">The Future of Hiring is Here</div>
                            <div>
                                <ul className="list-double mt-40">
                                    <li>
                                        <h5 className="fw-600">Punch or Release</h5>
                                        <p className="lt-text-secondary">Tracking offers in OfferX</p>
                                    </li>
                                    <li>
                                        <h5 className="fw-600">Receive Alerts</h5>
                                        <p className="lt-text-secondary">Counter offers and competing job offers</p>
                                    </li>
                                    <li>
                                        <h5 className="fw-600">Analyze Candidate Reliability</h5>
                                        <p className="lt-text-secondary">Behavioral insights and job history</p>
                                    </li>
                                    <li>
                                        <h5 className="fw-600">Make Confident Hiring Decisions</h5>
                                        <p className="lt-text-secondary">Secure your talent pipeline</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="new-card text-center">
                                <div className="seo-progress text-center">
                                    <div className="circle-progress">
                                        {ShowCaseData.map((progress) => (
                                            <ShowCaseProgress progress={progress} key={progress.id} />
                                        ))}
                                    </div>
                                </div>
                                <div className="fs-20 my-3">
                                    80% of our users have experienced <br />
                                    reduced candidate ghosting with OfferX.
                                </div>
                                <NavLink to={routes.contact} target="_blank" rel="noopener noreferrer">
                                    <button className="btn btn-primary h-44">Get Started Now</button>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section data-aos="fade-up" data-aos-delay="200">
                <div className="container mb-4">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <h1 className="fw-600 fs-28 mb-3">Webinars</h1>
                                <p className="fs-14 lt-text-secondary mb-5">
                                    OfferX presents expert-led HR webinars to tackle candidate ghosting and strengthen
                                    the HR community!
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {latestWebinars.map((item) => (
                            <div className="col-lg-4 col-md-6 d-flex">
                                <div
                                    className="card lt-shadow-md border-default border-radius-12 mb-4"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    <NavLink to={item.route}>
                                        <div className="thumb_bg">
                                            <img loading="lazy" src={item.img} className="img-fluid" alt="..." />
                                        </div>
                                    </NavLink>
                                    <div className="card-body">
                                        {item.heading.includes('<') ? (
                                            <div
                                                className="card-title fw-600 mb-3"
                                                dangerouslySetInnerHTML={{
                                                    __html: `<span class="fs-24">Say Goodbye To Candidate Backouts!!</span> 
                                         <span class="fs-14">(Webinar with Krishna Padisetty)</span>`,
                                                }}
                                            ></div>
                                        ) : (
                                            <h5 className="card-title fw-600 mb-3 fs-24">{item.heading}</h5>
                                        )}
                                        {item.subject.includes('<') ? (
                                            <p
                                                className="card-text fs-12 lt-text-secondary"
                                                dangerouslySetInnerHTML={{
                                                    __html: `Tired of dealing with last-minute candidate withdrawals and unexpected
                                                                    employee exits? In this exclusive webinar recording, we introduce 
                                                                    <span class="fw-600">OfferX's Unified Solution</span> —a game-changer
                                                                    for HR professionals and recruiters looking to tackle these challenges
                                                                    head-on.`,
                                                }}
                                            ></p>
                                        ) : (
                                            <p className="card-text fs-12 lt-text-secondary">{item.subject}</p>
                                        )}
                                        <div className="lt-text-primary-alt fs-12 mb-3">{item.date}</div>
                                    </div>
                                    <div
                                        className="card-footer"
                                        style={{
                                            border: 'none',
                                            background: 'transparent',
                                            paddingTop: '20px',
                                            paddingBottom: '20px',
                                        }}
                                    >
                                        <NavLink to={item.route}>
                                            <a href="" target="_blank" className="btn btn-primary">
                                                Webinar Recording
                                            </a>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-12">
                            <div className="text-center">
                                <NavLink to={routes.webinars} target="_blank" rel="noopener noreferrer">
                                    <button className="btn btn-primary social-next-button h-44">Explore More</button>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* client testimonial carousel starts */}
            <section className="reg-light-blue py-5 ps-lg-0 client-testimonial position-relative">
                <NavLink to={routes.contact}>
                    <div className="contact-widgets">
                        <img loading="lazy" src={contactWidget} alt="Contact Us" className="mb-2" />
                    </div>
                </NavLink>
                <div className="social-media-widgets2">
                    <div>
                        <a
                            rel="noreferrer"
                            href="https://www.linkedin.com/company/offer-x"
                            target="_blank"
                            title="Linkedin"
                        >
                            <img loading="lazy" src={linkedinNew} alt="LinkedIn" className="mb-2" />
                        </a>
                    </div>
                    <div>
                        <a
                            rel="noreferrer"
                            href="https://www.facebook.com/OfferX.india"
                            target="_blank"
                            title="Facebook"
                        >
                            <img loading="lazy" src={fbNew} alt="Facebook" />
                        </a>
                    </div>
                </div>
                <div className="container">
                    {/* <div className="client-testimonial-steps" data-aos="fade-up" data-aos-delay="200"> */}
                    <div className={`client-testimonial-steps ${expandedIndex ? 'readLessHeight' : 'readMoreHeight'}`}>
                        <div className="text-center">
                            <h1 className="fw-600 fs-28 mb-3">Client Testimonials</h1>
                            <p className="fs-14 lt-text-secondary mb-5">
                                The best way to learn about our product is from our customers
                            </p>
                        </div>
                        <div
                            id="testimonialIndicators"
                            className="carousel slide carousel-container"
                            data-bs-ride="carousel"
                            onSelect={handleSelectedExpand}
                        >
                            <div className={`carousel-inner ${expandedIndex ? 'readLessHeight' : 'readMoreHeight'}`}>
                                <div className="carousel-item active">
                                    <div className="container mb-4">
                                        <div className="row align-items-center">
                                            <div
                                                className="col-md-5 order-lg-1 order-2 mt-lg-0 mt-3"
                                                data-aos="fade-up"
                                                data-aos-delay="200"
                                            >
                                                <div className="client-quote-box ab-card">
                                                    <div className="client-quote-div">
                                                        <img loading="lazy" src={clientQuote} alt="Quote" />
                                                    </div>
                                                    <div className="ms-lg-5 client-quote-box-content">
                                                        <span className="fs-20 fw-700 me-1">80%</span>
                                                        <span className="fs-18">
                                                            {LandingPageMessages.abilashTestimony}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end mt-3">
                                                    <div className="sign-card">
                                                        <div className="d-flex align-items-center justify-content-end">
                                                            <div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={testiSmallImg1}
                                                                    alt="Abilash Perumandla"
                                                                    className="avatar avatar--xxs me-2"
                                                                />
                                                            </div>
                                                            <div className="text-start mt-3">
                                                                <div className="fs-14 fw-600 mb-0">
                                                                    Abilash Perumandla
                                                                </div>
                                                                <div className="fs-12 mb-1">
                                                                    Head of Human Resources
                                                                </div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={wallero}
                                                                    alt="Wallero"
                                                                    className="sign-pic"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-7 order-lg-2 order-1">
                                                <div
                                                    className="ox-video-poster ox-video-poster-2 d-flex align-items-center justify-content-center cursor-pointer"
                                                    onClick={() => setVideoShowClient(true)}
                                                >
                                                    {!videwShowClient ? (
                                                        <div className="text-center">
                                                            <div className="circle">
                                                                <i className="bi bi-play-fill play-icon"></i>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <video
                                                                controls
                                                                poster={clientTestimonialImg}
                                                                preload="none"
                                                                playsInline
                                                                controlsList="nodownload"
                                                                autoPlay
                                                            >
                                                                <source
                                                                    src={VIDEO_URLS.ClientTestiVideo}
                                                                    type="video/mp4"
                                                                />
                                                                Your browser does not support the video tag.
                                                            </video>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="container mb-4">
                                        <div className="row align-items-center justify-content-center">
                                            <div className="col-md-9">
                                                <div className="client-quote-box">
                                                    <div className="client-quote-div">
                                                        <img loading="lazy" src={clientQuote} alt="Quote" />
                                                    </div>
                                                    <div className="ms-lg-5 client-quote-box-content py-2">
                                                        <p className="fs-12 mb-3">{LandingPageMessages.annePriyaP1}</p>
                                                        <p className="fs-12 mb-3">{LandingPageMessages.annePriyaP2}</p>
                                                        <p className="fs-12">{LandingPageMessages.annePriyaP3}</p>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end mt-3">
                                                    <div className="sign-card-2">
                                                        <div className="d-flex align-items-center justify-content-end">
                                                            <div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={testiImg2}
                                                                    alt="Anne Priya"
                                                                    className="avatar avatar--xxs me-2"
                                                                />
                                                            </div>
                                                            <div className="text-start mt-3">
                                                                <div className="fs-14 fw-600 mb-0">Anne Priya</div>
                                                                <div className="fs-12 mb-1">HR Manager</div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={implantaire}
                                                                    alt="Implantaire"
                                                                    className="sign-pic"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mobile-hide">
                                                <div className="">
                                                    <img
                                                        loading="lazy"
                                                        src={testiImg2}
                                                        alt="Anne Priya"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="container mb-4">
                                        <div className="row align-items-center justify-content-center">
                                            <div className="col-md-9">
                                                <div className="client-quote-box">
                                                    <div className="client-quote-div">
                                                        <img loading="lazy" src={clientQuote} alt="Quote" />
                                                    </div>
                                                    <div className="ms-lg-5 client-quote-box-content client-quote3-py">
                                                        <p className="fs-14">
                                                            {LandingPageMessages.sandhyaBhaskaranTestimony}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end mt-3">
                                                    <div className="sign-card-2">
                                                        <div className="d-flex align-items-center justify-content-end">
                                                            <div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={testiImg4}
                                                                    alt="Sandhya Baskaran"
                                                                    className="avatar avatar--xxs me-2"
                                                                />
                                                            </div>
                                                            <div className="text-start mt-3">
                                                                <div className="fs-14 fw-600 mb-0">
                                                                    Sandhya Baskaran
                                                                </div>
                                                                <div className="fs-12 mb-1">HR Generalist</div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={acviss}
                                                                    alt="Acviss"
                                                                    className="sign-pic"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mobile-hide">
                                                <div className="" data-aos="fade-up" data-aos-delay="200">
                                                    <img
                                                        loading="lazy"
                                                        src={testiImg4}
                                                        alt="Sandhya Baskaran"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="container mb-4">
                                        <div className="row align-items-center justify-content-center">
                                            <div className="col-md-9">
                                                <div className="position-relative">
                                                    <div className="client-quote-box">
                                                        <div className="client-quote-div">
                                                            <img loading="lazy" src={clientQuote} alt="Quote" />
                                                        </div>
                                                        <div className="ms-lg-5 client-quote-box-content client-quote3-py">
                                                            {!expandedIndex ? (
                                                                <span className="fs-14">
                                                                    {LandingPageMessages.ramGopalP1}
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    <p className="fs-14">
                                                                        {LandingPageMessages.ramGopalP1}
                                                                    </p>
                                                                    <p className="fs-14 mt-2">
                                                                        {LandingPageMessages.ramGopalP2}
                                                                    </p>
                                                                    <p className="fs-14 mt-2">
                                                                        {LandingPageMessages.ramGopalP3}
                                                                    </p>
                                                                </span>
                                                            )}
                                                            <span>
                                                                <button
                                                                    className="btn btn-link p-0 lt-text-primary-alt readMoreBtn"
                                                                    onClick={() => setExpandedIndex(!expandedIndex)}
                                                                >
                                                                    {expandedIndex ? 'Read less' : 'Read more'}
                                                                </button>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end mt-3">
                                                    <div className="sign-card-2">
                                                        <div className="d-flex align-items-center justify-content-end">
                                                            <div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={testiSmallImg4}
                                                                    alt="Nallagatla Vijaya Ram Gopal"
                                                                    className="avatar avatar--xxs me-2"
                                                                />
                                                            </div>
                                                            <div className="text-start mt-3">
                                                                <div className="fs-14 fw-600 mb-0">
                                                                    Nallagatla Vijaya Ram Gopal
                                                                </div>
                                                                <div className="fs-12 mb-1">HR Head</div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={ulearn}
                                                                    alt="ULEARN"
                                                                    className="sign-pic"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mobile-hide">
                                                <div className="" data-aos="fade-up" data-aos-delay="200">
                                                    <img
                                                        loading="lazy"
                                                        src={testiImg5}
                                                        alt="Nallagatla Vijaya Ram Gopal"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="container mb-4">
                                        <div className="row align-items-center justify-content-center">
                                            <div className="col-md-9">
                                                <div className="position-relative">
                                                    <div className="client-quote-box">
                                                        <div className="client-quote-div">
                                                            <img loading="lazy" src={clientQuote} alt="Quote" />
                                                        </div>
                                                        <div className="ms-lg-5 client-quote-box-content client-quote3-py">
                                                            {!expandedIndex ? (
                                                                <>
                                                                    <p className="fs-14">
                                                                        OfferX has truly revolutionized our operations,
                                                                        streamlining our candidate onboarding process
                                                                        and eliminating recruitment ghosting issues like
                                                                        never before. Its comprehensive solution allows
                                                                        us to swiftly assess candidate responses and
                                                                        access their complete history.
                                                                    </p>
                                                                    <p className="fs-14 mt-2">
                                                                        We eagerly anticipate future updates that will
                                                                        further enhance this platform. The help center
                                                                        has been an invaluable resource for us, always
                                                                        providing immediate assistance whenever we
                                                                        encounter challenges.
                                                                    </p>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <p className="fs-14">
                                                                        OfferX has truly revolutionized our operations,
                                                                        streamlining our candidate onboarding process
                                                                        and eliminating recruitment ghosting issues like
                                                                        never before. Its comprehensive solution allows
                                                                        us to swiftly assess candidate responses and
                                                                        access their complete history.
                                                                    </p>
                                                                    <p className="fs-14 mt-2">
                                                                        We eagerly anticipate future updates that will
                                                                        further enhance this platform. The help center
                                                                        has been an invaluable resource for us, always
                                                                        providing immediate assistance whenever we
                                                                        encounter challenges.
                                                                    </p>
                                                                    <p className="fs-14 mt-2">
                                                                        We are committed to leveraging this platform
                                                                        extensively in the future. I wholeheartedly
                                                                        recommend that all companies explore the
                                                                        benefits of registering on the OfferX platform
                                                                        to simplify and optimize their onboarding
                                                                        processes.
                                                                    </p>
                                                                </>
                                                            )}
                                                            <span>
                                                                <button
                                                                    className="btn btn-link p-0 lt-text-primary-alt readMoreBtn"
                                                                    onClick={() => setExpandedIndex(!expandedIndex)}
                                                                >
                                                                    {expandedIndex ? 'Read less' : 'Read more'}
                                                                </button>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end mt-3">
                                                    <div className="sign-card-2">
                                                        <div className="d-flex align-items-center justify-content-end">
                                                            <div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={testiSmallImg6}
                                                                    alt="Nagendra Shivarajegowda"
                                                                    className="avatar avatar--xxs me-2"
                                                                />
                                                            </div>
                                                            <div className="text-start mt-3">
                                                                <div className="fs-14 fw-600 mb-0">
                                                                    Nagendra Shivarajegowda
                                                                </div>
                                                                <div className="fs-12 mb-1">HR Manager</div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={inspiringTouch}
                                                                    alt="Inspiring Touch"
                                                                    className="sign-pic"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mobile-hide">
                                                <div className="" data-aos="fade-up" data-aos-delay="200">
                                                    <img
                                                        loading="lazy"
                                                        src={testiImg6}
                                                        alt="Nagendra Shivarajegowda"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="container mb-4">
                                        <div className="row align-items-center justify-content-center">
                                            <div className="col-md-9">
                                                <div className="client-quote-box">
                                                    <div className="client-quote-div">
                                                        <img loading="lazy" src={clientQuote} alt="Quote" />
                                                    </div>
                                                    <div className="ms-lg-5 client-quote-box-content client-quote3-py">
                                                        <p className="fs-14">
                                                            OfferX has revolutionized our approach to hiring. With its
                                                            Onboarding and Esign Features, the platform simplifies the
                                                            onboarding process of new hires while effectively preventing
                                                            candidate disappearances. I've noticed a drastic change
                                                            after bringing OfferX into our hiring process. I highly
                                                            recommend OfferX to any company seeking to enhance their
                                                            hiring process.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end mt-3">
                                                    <div className="sign-card-2">
                                                        <div className="d-flex align-items-center justify-content-end">
                                                            <div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={testiSmallImg7}
                                                                    alt="Sarath Patro"
                                                                    className="avatar avatar--xxs me-2"
                                                                />
                                                            </div>
                                                            <div className="text-start mt-3">
                                                                <div className="fs-14 fw-600 mb-0">Sarath Patro</div>
                                                                <div className="fs-12 mb-1">CEO</div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={revSoc}
                                                                    alt="Revsoc Digital Marketing Agency"
                                                                    className="sign-pic"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mobile-hide">
                                                <div className="" data-aos="fade-up" data-aos-delay="200">
                                                    <img
                                                        loading="lazy"
                                                        src={testiImg7}
                                                        alt="Sarath Patro"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="container mb-4">
                                        <div className="row align-items-center justify-content-center">
                                            <div className="col-md-9">
                                                <div className="client-quote-box">
                                                    <div className="client-quote-div">
                                                        <img loading="lazy" src={clientQuote} alt="Quote" />
                                                    </div>
                                                    <div className="ms-lg-5 client-quote-box-content client-quote3-py">
                                                        <p className="fs-14">
                                                            In our experience, last-minute candidate offer ghosting and
                                                            early-stage attrition are key challenges. After reviewing
                                                            OfferX's interface, it effectively addresses these issues by
                                                            ensuring candidates maintain accountability and communicate
                                                            properly when declining offers, while also tackling
                                                            absconding due to infant attrition.
                                                        </p>
                                                        <p className="fs-14 mt-2">
                                                            I wish the OfferX team continued success in their efforts to
                                                            bridge the gap in managing offer ghosting.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end mt-3">
                                                    <div className="sign-card-2">
                                                        <div className="d-flex align-items-center justify-content-end">
                                                            <div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={testiSmallImg8}
                                                                    alt="Rajiv Tiwari"
                                                                    className="avatar avatar--xxs me-2"
                                                                />
                                                            </div>
                                                            <div className="text-start mt-3">
                                                                <div className="fs-14 fw-600 mb-0">Rajiv Tiwari</div>
                                                                <div className="fs-12 mb-1">
                                                                    Director Talent Acquisition
                                                                </div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={virtusaLogo}
                                                                    alt="Virtusa"
                                                                    style={{ width: 70 }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mobile-hide">
                                                <div className="" data-aos="fade-up" data-aos-delay="200">
                                                    <img
                                                        loading="lazy"
                                                        src={testiImg8}
                                                        alt="Rajiv Tiwari"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="container mb-4">
                                        <div className="row align-items-center justify-content-center">
                                            <div className="col-md-9">
                                                <div className="client-quote-box">
                                                    <div className="client-quote-div">
                                                        <img loading="lazy" src={clientQuote} alt="Quote" />
                                                    </div>
                                                    <div className="ms-lg-5 client-quote-box-content client-quote3-py">
                                                        <p className="fs-14">
                                                            We used the OfferX tool, and it has been performing
                                                            exceptionally well. The platform is user-friendly and highly
                                                            presentable, with its approach receiving significant
                                                            appreciation. OfferX effectively addresses a critical issue
                                                            for recruiters: employee ghosting. It allows us to send
                                                            offers to potential employees and efficiently record their
                                                            details. The platform's comprehensive statistics feature
                                                            enables us to track how many offers were sent, who accepted
                                                            or declined, and the reasons behind their decisions. This
                                                            helps us build a robust database for future hiring.
                                                            Additionally, the tool includes a two-way review system for
                                                            both applicants and employers, specifically addressing cases
                                                            of ghosting. I believe this platform has the potential to
                                                            become a game-changer in the industry.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end mt-3">
                                                    <div className="sign-card-2">
                                                        <div className="d-flex align-items-center justify-content-end">
                                                            <div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={testiSmallImg9}
                                                                    alt="Rajiv Tiwari"
                                                                    className="avatar avatar--xxs me-2"
                                                                />
                                                            </div>
                                                            <div className="text-start mt-3">
                                                                <div className="fs-14 fw-600 mb-0">Vinod Kumar</div>
                                                                <div className="fs-12 mb-1">HR Manager</div>
                                                                <img
                                                                    loading="lazy"
                                                                    src={comtecLogo}
                                                                    alt="ComTec IT Services India P Ltd."
                                                                    style={{ width: 70 }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 mobile-hide">
                                                <div className="" data-aos="fade-up" data-aos-delay="200">
                                                    <img
                                                        loading="lazy"
                                                        src={testiImg9}
                                                        alt="Vinod Kumar"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-indicators mt-0">
                                <button
                                    className="carousel-control-prev"
                                    type="button"
                                    data-bs-target="#testimonialIndicators"
                                    data-bs-slide="prev"
                                >
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <div className="carousel-ind">
                                    <button
                                        type="button"
                                        ref={buttonRef}
                                        data-bs-target="#testimonialIndicators"
                                        data-bs-slide-to="0"
                                        className="active"
                                        aria-current="true"
                                        aria-label="Slide 1"
                                    ></button>
                                    {testimonialIndicatorButton.map((item, index) => (
                                        <button
                                            key={index}
                                            type="button"
                                            data-bs-target="#testimonialIndicators"
                                            data-bs-slide-to={item.databsslideto}
                                            aria-label={item.arialabel}
                                        ></button>
                                    ))}
                                </div>
                                <button
                                    className="carousel-control-next"
                                    type="button"
                                    data-bs-target="#testimonialIndicators"
                                    data-bs-slide="next"
                                >
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Suspense fallback={<div>Loading...</div>}>
                <Footer />
            </Suspense>
        </>
    );
};

export default Main;

export function encodeName(name: string) {
    return name
        .replace(/&/g, '')
        .replace(/[^a-zA-Z0-9]/g, '')
        .replace(/-+/g, '')
        .replace(/^-|-$/g, '')
        .toLowerCase();
}
